export default {
  title: {
    en: 'Want to get a perfume even cheaper and faster?',
  },
  subTitle: {
    en: `
      Upgrade to two or three bottles a month to discover more scents and save money and get perfumes earlier.
      You queue will refill automatically.
    `,
  },
  hint: {
    en: 'Most popular!',
  },
}
